"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.artists = void 0;
require("reflect-metadata");
const toccata_1 = require("@musicaudienceexchange/toccata");
const app_1 = require("../app");
const artists_1 = require("../firestore/artists");
// eslint-disable-next-line @typescript-eslint/no-namespace
var artists;
(function (artists) {
    class ArtistGroupMemberBase extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ArtistGroupMemberBase.prototype, "name", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], ArtistGroupMemberBase.prototype, "email", void 0);
    __decorate([
        toccata_1.validator.Validate(artists_1.ArtistGroupRoleValidator)
    ], ArtistGroupMemberBase.prototype, "roles", void 0);
    artists.ArtistGroupMemberBase = ArtistGroupMemberBase;
    class ArtistGroupMember extends ArtistGroupMemberBase {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ArtistGroupMember.prototype, "uid", void 0);
    __decorate([
        toccata_1.validator.IsBoolean()
    ], ArtistGroupMember.prototype, "verified", void 0);
    artists.ArtistGroupMember = ArtistGroupMember;
    class GetArtistGroupRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], GetArtistGroupRequest.prototype, "groupId", void 0);
    artists.GetArtistGroupRequest = GetArtistGroupRequest;
    class GetArtistGroupResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.members = [];
        }
    }
    __decorate([
        (0, toccata_1.TransformValidateModel)(artists_1.ArtistGroup)
    ], GetArtistGroupResponse.prototype, "group", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(ArtistGroupMember, { each: true })
    ], GetArtistGroupResponse.prototype, "members", void 0);
    artists.GetArtistGroupResponse = GetArtistGroupResponse;
    class UpdateArtistGroupMemberRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], UpdateArtistGroupMemberRequest.prototype, "groupId", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(ArtistGroupMemberBase)
    ], UpdateArtistGroupMemberRequest.prototype, "member", void 0);
    artists.UpdateArtistGroupMemberRequest = UpdateArtistGroupMemberRequest;
    class UpdateArtistGroupMemberResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], UpdateArtistGroupMemberResponse.prototype, "success", void 0);
    artists.UpdateArtistGroupMemberResponse = UpdateArtistGroupMemberResponse;
})(artists = exports.artists || (exports.artists = {}));
function init(fApp) {
    const functions = fApp ? fApp.functions() : app_1.app.firebase.functions();
    return {
        /**
         *
         */
        getArtistGroup: (0, toccata_1.createFunction)(functions, 'shoutout-getArtistGroup', artists.GetArtistGroupRequest, artists.GetArtistGroupResponse),
        /**
         *
         */
        updateArtistGroupMember: (0, toccata_1.createFunction)(functions, 'shoutout-updateArtistGroupMember', artists.UpdateArtistGroupMemberRequest, artists.UpdateArtistGroupMemberResponse),
    };
}
exports.init = init;
//# sourceMappingURL=artists.js.map